import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";

export default function AiUsageView() {
  const { apiFetch, t, dark, card, btnSm, userRole } = useApp();
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);
  const [loading, setLoading] = useState(false);

  const load = async (d = days) => {
    setLoading(true);
    try {
      const r = await apiFetch(`/api/ai-usage/summary?days=${d}`);
      const j = await r.json();
      setData(j);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { if (userRole === "admin") load(days); }, [days, userRole]);

  if (userRole !== "admin") return <div style={{ padding: 24 }}>Доступ тільки для адмінів</div>;

  return (
    <div style={{ padding: "16px 24px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>💰 AI Витрати</h2>
        <select value={days} onChange={e => setDays(parseInt(e.target.value, 10))} style={{ marginLeft: "auto", padding: "6px 10px", borderRadius: 6, border: `1px solid ${t.border}`, background: t.bgCard, color: t.text, fontSize: 13 }}>
          <option value={1}>За 1 день</option>
          <option value={7}>За 7 днів</option>
          <option value={30}>За 30 днів</option>
          <option value={90}>За 90 днів</option>
        </select>
        <button onClick={() => load(days)} disabled={loading} style={btnSm}>{loading ? "..." : "↻"}</button>
      </div>

      {data && (
        <>
          <div style={{ ...card, padding: 18, marginBottom: 16, display: "flex", gap: 24, alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 11, color: t.textMuted, fontWeight: 600 }}>ВСЬОГО ВИТРАЧЕНО ({days}д)</div>
              <div style={{ fontSize: 32, fontWeight: 800, color: data.total.cost > 100 ? "#ef4444" : data.total.cost > 30 ? "#f59e0b" : "#10b981" }}>${data.total.cost.toFixed(2)}</div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: t.textMuted, fontWeight: 600 }}>API ВИКЛИКІВ</div>
              <div style={{ fontSize: 24, fontWeight: 700 }}>{data.total.calls.toLocaleString()}</div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: t.textMuted, fontWeight: 600 }}>СЕРЕДНЯ ВАРТІСТЬ ВИКЛИКУ</div>
              <div style={{ fontSize: 16, fontWeight: 600 }}>${data.total.calls > 0 ? (data.total.cost / data.total.calls).toFixed(4) : "0"}</div>
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
            <div style={{ ...card, padding: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>📊 По моделях</div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ color: t.textMuted, textAlign: "left" }}>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600 }}>Модель</th>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600 }}>Source</th>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600, textAlign: "right" }}>Викл.</th>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600, textAlign: "right" }}>$</th>
                  </tr>
                </thead>
                <tbody>
                  {data.byModel.map((r, i) => (
                    <tr key={i}>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontFamily: "monospace", fontSize: 11 }}>{r.model}</td>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, color: t.textMuted, fontSize: 11 }}>{r.source}</td>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, textAlign: "right" }}>{Number(r.calls).toLocaleString()}</td>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, textAlign: "right", fontWeight: 600 }}>${r.cost.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ ...card, padding: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>🏢 По проектах (TOP 30)</div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ color: t.textMuted, textAlign: "left" }}>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600 }}>Проект</th>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600, textAlign: "right" }}>Викл.</th>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600, textAlign: "right" }}>$</th>
                  </tr>
                </thead>
                <tbody>
                  {data.byProject.map((r, i) => (
                    <tr key={i}>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontSize: 12 }}>
                        {r.project_name || <span style={{ color: t.textMuted }}>(без проекта)</span>}
                        {r.domain && <div style={{ fontSize: 9, color: t.textMuted }}>{r.domain}</div>}
                      </td>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, textAlign: "right" }}>{Number(r.calls).toLocaleString()}</td>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, textAlign: "right", fontWeight: 600 }}>${r.cost.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {data.timeline.length > 0 && (
            <div style={{ ...card, padding: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>📈 Динаміка по днях</div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ color: t.textMuted, textAlign: "left" }}>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600 }}>Дата</th>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600, textAlign: "right" }}>Викликів</th>
                    <th style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, fontWeight: 600, textAlign: "right" }}>$</th>
                  </tr>
                </thead>
                <tbody>
                  {data.timeline.slice().reverse().map((r, i) => (
                    <tr key={i}>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}` }}>{String(r.date).slice(0, 10)}</td>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, textAlign: "right" }}>{Number(r.calls).toLocaleString()}</td>
                      <td style={{ padding: "6px 4px", borderBottom: `1px solid ${t.border}`, textAlign: "right", fontWeight: 600 }}>${r.cost.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
